// DEV-ONLY · DEVICE PASS 02 — CHRIS INSZENIERUNG (Korrektur) für B1 + B4.
//
// LOCK: Die fotorealistischen CL-Monitore sind freigegeben und werden NICHT
// verändert – identische Assets (device-b1-gbu.webp / device-b4-ampel-cut.webp),
// identische Spaltenbreiten (B1 40/60, B4 62/38 ~ vorher 64/36), identische
// Schatten/Crop/Farbwelt. Kein Hintergrund/Rahmen um die Geräte.
//
// GEÄNDERT (nur Chris + Bubble):
//  1) Chris deutlich größer & präsent (Desktop ~1,8–2,4× ggü. vorher),
//     bildet mit dem Monitor eine gemeinsame Szene.
//  2) Pose nach visueller FUNKTION gewählt, nie aus der Bühne heraus:
//     · B1: Chris steht LINKS → Pose 23 (offene Präsentation nach RECHTS
//       zum Monitor/zur Suche).
//     · B4: Chris steht RECHTS → Pose 17 (offene linke Hand nach LINKS zur
//       Ampel 17/0/268), freundlicher Blick zum Betrachter.
//  3) Sprechblase gehört visuell zu Chris (eine Figurengruppe, Tail nach unten
//     auf Chris, Blase klein genug, damit Chris dominiert).
//  4) Eigene Mobile-Komposition (390): Produktbeweis groß → Chris klar sichtbar
//     → kurze Blase (kein proportionales Verkleinern des Desktops).
//
// Produktwahrheit unverändert: der Screen im Gerät ist der echte, unveränderte
// CLARTEXT-Screenshot. Kein Einfluss auf /abo (STOP-GATE bis Freigabe).
import { useEffect, useRef } from "react";
import AboChris from "@/components/abo/AboChris";
import { Badge } from "@/components/abo/AboStory";
import "@/pages/abo/abo.css";

const DEV = (name) => `/abo/devices/${name}`;
const OUTFIT =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap";

export default function AboDevicePhotoDevPreview() {
  const ref = useRef(null);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = OUTFIT;
    document.head.appendChild(link);
    ref.current?.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
    return () => link.remove();
  }, []);

  return (
    <div
      className="abo-root"
      lang="de"
      ref={ref}
      data-testid="abo-device-photo-dev"
      style={{ minHeight: "100vh" }}
    >
      <style>{`
        [data-testid="abo-device-photo-dev"] .reveal{opacity:1 !important;transform:none !important;}
        [data-testid="abo-device-photo-dev"] .dev-label{max-width:1280px;margin:0 auto;padding:22px 24px 0;font:600 0.72rem/1.4 "Outfit",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#94a3b8;}
        [data-testid="abo-device-photo-dev"] .dev-note{max-width:1280px;margin:0 auto;padding:4px 24px 0;font:500 0.8rem/1.5 "Outfit",sans-serif;color:#64748b;}

        /* ---- LOCKED Monitore (unverändert) ---- */
        [data-testid="abo-device-photo-dev"] .cl-monitor{margin:0;}
        [data-testid="abo-device-photo-dev"] .cl-monitor img{display:block;width:100%;height:auto;filter:drop-shadow(0 32px 42px rgba(15,40,80,.26));}
        [data-testid="abo-device-photo-dev"] .b4-monitor{margin:0;}
        [data-testid="abo-device-photo-dev"] .b4-monitor img{display:block;width:100%;height:auto;filter:drop-shadow(0 34px 44px rgba(15,40,80,.28));}

        /* ---- Chris-Gruppe: Blase sitzt auf einer GROSSEN Figur = eine Einheit ---- */
        [data-testid="abo-device-photo-dev"] .dp-chris .abo-chris{flex-direction:column-reverse;align-items:flex-start;gap:2px;}
        [data-testid="abo-device-photo-dev"] .dp-chris .abo-chris-fig{filter:drop-shadow(0 26px 34px rgba(15,40,80,.20));margin-top:-10px;}
        [data-testid="abo-device-photo-dev"] .dp-chris .abo-chris-bubble{position:relative;border:1px solid #e6edf5;box-shadow:0 18px 44px rgba(15,40,80,.16);color:var(--ink);font-weight:600;max-width:300px;margin:0 0 2px;font-size:.95rem;line-height:1.45;}
        [data-testid="abo-device-photo-dev"] .dp-chris .abo-chris-bubble::before{display:none;}
        [data-testid="abo-device-photo-dev"] .dp-chris .abo-chris-bubble::after{content:"";position:absolute;left:46px;right:auto;top:auto;bottom:-9px;width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-top:10px solid #fff;border-bottom:0;}

        /* ---- B1 · Grid (Mobile: Titel → Monitor → Chris) ---- */
        [data-testid="abo-device-photo-dev"] .dp-b1-grid{display:grid;grid-template-columns:1fr;gap:26px;grid-template-areas:"copy" "mon" "chris";}
        [data-testid="abo-device-photo-dev"] .dp-b1-copy{grid-area:copy;}
        [data-testid="abo-device-photo-dev"] .dp-b1-media{grid-area:mon;}
        [data-testid="abo-device-photo-dev"] .dp-b1-chris{grid-area:chris;}
        [data-testid="abo-device-photo-dev"] .dp-b1-chris .abo-chris-fig{height:216px;}

        /* ---- B4 · Grid (Mobile: Monitor → Chris) ---- */
        [data-testid="abo-device-photo-dev"] .dp-b4-grid{display:grid;grid-template-columns:1fr;gap:24px;grid-template-areas:"mon" "chris";margin-top:24px;align-items:center;}
        [data-testid="abo-device-photo-dev"] .dp-b4-monitor{grid-area:mon;}
        [data-testid="abo-device-photo-dev"] .dp-b4-chris{grid-area:chris;}
        [data-testid="abo-device-photo-dev"] .dp-b4-chris .abo-chris-fig{height:236px;}

        @media(min-width:1000px){
          /* B1: Chris links unter der Copy, präsentiert nach rechts zum Monitor */
          [data-testid="abo-device-photo-dev"] .dp-b1-grid{grid-template-columns:40% 60%;column-gap:56px;row-gap:18px;grid-template-areas:"copy mon" "chris mon";align-items:start;}
          [data-testid="abo-device-photo-dev"] .dp-b1-media{align-self:center;}
          [data-testid="abo-device-photo-dev"] .dp-b1-chris{align-self:start;margin-top:6px;}
          [data-testid="abo-device-photo-dev"] .dp-b1-chris .abo-chris-fig{height:clamp(290px,24vw,352px);}
          [data-testid="abo-device-photo-dev"] .dp-b1-chris .abo-chris-bubble{max-width:322px;font-size:1rem;}

          /* B4: Monitor groß links, Chris groß rechts, Geste nach links zur Ampel */
          [data-testid="abo-device-photo-dev"] .dp-b4-grid{grid-template-columns:64% 36%;column-gap:36px;grid-template-areas:"mon chris";align-items:center;margin-top:36px;}
          [data-testid="abo-device-photo-dev"] .dp-b4-chris{align-self:center;}
          [data-testid="abo-device-photo-dev"] .dp-b4-chris .abo-chris-fig{height:clamp(380px,31vw,466px);}
          [data-testid="abo-device-photo-dev"] .dp-b4-chris .abo-chris-bubble{max-width:330px;font-size:1rem;}
        }
      `}</style>

      <div className="dev-label">Device Pass 02 · Chris-Inszenierung · Korrektur (Monitore gelockt)</div>
      <div className="dev-note">
        Nur Chris + Sprechblase geändert: größer, richtungsrichtig zum
        Produktbeweis, als Figurengruppe. Monitore, Screenshots, Crop und
        Farbwelt unverändert.
      </div>

      {/* ---------- B1 · GBU · Chris links → präsentiert nach rechts (Pose 23) ---------- */}
      <div className="dev-label">Device Pass 02 · B1 Gefährdungsbeurteilung</div>
      <section className="abo-stage abo-stage--light" data-testid="devp-stage-gbu">
        <div className="abo-stage-wrap">
          <div className="dp-b1-grid">
            <div className="dp-b1-copy reveal">
              <div className="abo-stage-meta">
                <span className="abo-stage-kicker">Was Chris für Sie übernimmt</span>
                <Badge kind="grund" />
              </div>
              <h2 className="abo-stage-title">
                Sagen Sie nur, worum es geht. Den Rest übernimmt CLartext.
              </h2>
              <p className="abo-stage-line">Tippen. Vorschlag prüfen. Freigeben.</p>
            </div>

            <div className="dp-b1-media reveal">
              <figure className="cl-monitor">
                <img
                  src={DEV("device-b1-gbu.webp")}
                  alt="CLartext Gefährdungsbeurteilung auf einem hochwertigen Desktop-Gerät – ein Stichwort ins Suchfeld, die passende Vorlage wird vorgeschlagen"
                  data-testid="devp-img-gbu"
                />
              </figure>
              <p className="abo-stage-cap">
                CLartext findet die passende Gefährdungsbeurteilung und bereitet
                sie für Sie vor.
              </p>
            </div>

            <div className="dp-b1-chris dp-chris reveal">
              <AboChris
                pose={23}
                size="md"
                testId="devp-chris-gbu"
                text="Ich finde die passende Gefährdungsbeurteilung und bereite alles für Sie vor – Sie prüfen nur noch."
              />
            </div>
          </div>
        </div>
      </section>

      {/* ---------- B4 · Wiedervorlage/Ampel · Chris rechts → Geste nach links (Pose 17) ---------- */}
      <div className="dev-label">Device Pass 02 · B4 Wiedervorlage / Ampel</div>
      <section className="abo-stage abo-stage--wv" data-testid="devp-stage-wv">
        <div className="abo-stage-wrap">
          <header className="abo-wv-head reveal">
            <span className="abo-stage-kicker">Wiederholungen laufen weiter</span>
            <h2 className="abo-stage-title">
              Einmal eingerichtet. Beim nächsten Mal kümmert sich Chris wieder darum.
            </h2>
          </header>

          <div className="dp-b4-grid reveal">
            <figure className="b4-monitor dp-b4-monitor">
              <img
                src={DEV("device-b4-ampel-cut.webp")}
                alt="CLartext Unterweisungsübersicht auf einem hochwertigen Desktop-Gerät: Handlungsbedarf 17, Bald fällig 0, Erledigt 268 – mit fälligen Aufgaben und Datum"
                data-testid="devp-img-wv"
              />
            </figure>

            <div className="dp-b4-chris dp-chris">
              <AboChris
                pose={17}
                size="md"
                testId="devp-chris-wv"
                text="Ich lege die nächste Wiederholung automatisch an und bringe sie wieder zu Ihrem Mitarbeiter. Sie behalten nur den Stand im Blick."
              />
            </div>
          </div>

          <div className="abo-wv-foot reveal">
            <p className="abo-wv-benefit">Keine Kalenderlisten. Kein erneutes Anlegen.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
